import React from 'react';
import useEvent from '../hooks/useEvent';
import { hasFeature } from '../../state/zustand';
import { Status, useSyncPreemOrdersMutation } from '../../graphql';
import { toast } from 'react-toastify';
import { ApolloError } from '@apollo/client';
import { DropdownButton, Menu, MenuItem } from '../ui';

export function PreemUpdates(): JSX.Element | null {
  const isPreemToolsFeatureAvailable = hasFeature('preem_tools');
  const [syncOrdersMutation] = useSyncPreemOrdersMutation();

  const syncPreemOrders = useEvent(() => {
    const toastId = toast(`Syncing Preem orders`, {
      type: toast.TYPE.INFO,
      isLoading: true,
    });
    syncOrdersMutation()
      .then((syncOrdersResult) => {
        if (syncOrdersResult.errors && syncOrdersResult.errors.length > 0) {
          throw syncOrdersResult.errors;
        }
        const result = syncOrdersResult?.data?.syncPreemOrders;
        if (!result) {
          throw new Error('No data');
        }
        if (result.status === Status.ok) {
          toast.update(toastId, {
            render: `Sync orders successfully`,
            type: toast.TYPE.SUCCESS,
            isLoading: false,
          });
        } else {
          toast.update(toastId, {
            render: `Fail to sync orders`,
            type: toast.TYPE.ERROR,
            isLoading: false,
          });
          for (const log of result.errorLogs) {
            toast.error(log, {
              autoClose: false,
            });
          }
        }
      })
      .catch((err) => {
        toast.update(toastId, {
          render: `Fail to sync orders`,
          type: toast.TYPE.ERROR,
        });
        if (err instanceof ApolloError) {
          const messages = err.graphQLErrors.map((err) => err.message);
          for (const message of messages) {
            toast.error(message, {
              autoClose: false,
            });
          }
        }
      });
  });

  if (!isPreemToolsFeatureAvailable) return null;

  return (
    <DropdownButton variant="dark" label="Preem tools" mr={3}>
      <Menu hasShadow>
        <MenuItem label="Sync orders" onPress={syncPreemOrders} />
      </Menu>
    </DropdownButton>
  );
}
